const BRAND_ENABLED = process.env.FEATURE_BRAND_ENABLED === "true";

const BASE_MOBILE_MENU = [
  { title: "首页", name: "/home", vantIcon: "wap-home-o" },
  { title: "知识库", name: "/knowledge", vantIcon: "description" },
  { title: "全效", name: "/efficiency", chatgpt: true },
  { title: "我的", name: "/my", vantIcon: "contact" }
];

export function mobileMenu(user) {
  const items = BASE_MOBILE_MENU.map(item => Object.assign({}, item));
  if (BRAND_ENABLED && user && user.brandPost) {
    items.splice(items.length - 1, 0, { title: "品牌", name: "/brand", vantIcon: "fire-o" });
  }
  return items;
}

export { BRAND_ENABLED };



// WEBPACK FOOTER //
// ./src/config/menu.js